import React from "react";
import { motion } from "framer-motion";
import { Card } from "../ui/card";
import { useLanguage } from "../../App";

const CharacterCard = ({ character, active = false, onClick }) => {
  const { language } = useLanguage();
  const isEnglish = language === "en";
  const rarityLabel = {
    dasar: isEnglish ? "Basic" : "Dasar",
    shalih: isEnglish ? "Righteous" : "Shalih",
    teladan: isEnglish ? "Exemplary" : "Teladan",
    muttaqin: isEnglish ? "God-conscious" : "Muttaqin",
    common: isEnglish ? "Basic" : "Dasar",
    rare: isEnglish ? "Righteous" : "Shalih",
    epic: isEnglish ? "Exemplary" : "Teladan",
    legendary: isEnglish ? "God-conscious" : "Muttaqin",
  }[character.rarity || "dasar"];
  const ringColor = {
    dasar: "ring-gray-400",
    shalih: "ring-emerald-500",
    teladan: "ring-indigo-500",
    muttaqin: "ring-amber-500",
    common: "ring-gray-400",
    rare: "ring-emerald-500",
    epic: "ring-indigo-500",
    legendary: "ring-amber-500",
  }[character.rarity || "dasar"];
  return (
    <motion.div
      layout
      initial={false}
      animate={active ? { scale: 1.06 } : { scale: 0.94, opacity: 0.9 }}
      transition={{ type: "spring", stiffness: 280, damping: 24 }}
      className="basis-[220px] sm:basis-[260px] md:basis-[280px]"
      onClick={onClick}
    >
      <Card className={`${active ? `ring-2 ${ringColor} ring-offset-2 shadow-xl bg-gradient-to-br from-yellow-200 to-orange-200` : ""}`}>
        <div className="p-3 sm:p-4">
          <div className="relative">
            <div className="w-40 h-40 sm:w-48 sm:h-48 md:w-56 md:h-56 mx-auto rounded-2xl bg-card border-2 border-border flex items-center justify-center overflow-hidden">
              <img src={character.image} alt={character.name} className="w-full h-full object-contain" />
            </div>
            {character.rarity && (
              <span className="absolute top-1 left-1 px-2 py-0.5 rounded-full text-[10px] font-semibold bg-black/10 backdrop-blur text-foreground">
                {rarityLabel}
              </span>
            )}
          </div>
          <p className={`text-center mt-2 font-semibold ${active ? "text-amber-700" : "text-muted-foreground"}`}>
            {character.name}
          </p>
        </div>
      </Card>
    </motion.div>
  );
};

export default CharacterCard;
